module.exports = __webpack_public_path__ + "img/exit.1883fc3d.svg";